$(function(){
    if($(".page--register").length != 0){

        $(".password-link").click(function(){
            $('.password-group').toggle();
        });

        function getBusinessGroups(id){
            var url = 'business-type/' + id;
            $.ajax({
                url: url,
                dataType: 'json'
            })
            .done(function (data) {
                if(data.length != 0){
                    console.log(data);
                    $(".business-group-select select").html('<option value="">(Select one)</option>');
                    for(var i = 0 ; i < data.length; i++){
                        $(".business-group-select select").append(
                            '<option value="' + data[i].ID + '">' + data[i].Name + '</option>'
                        );
                    }
                    $(".business-group-select select").append(
                        '<option value="0">Other</option>'
                    );
                    $(".business-group-select").show();
                }else{
                    //$(".company-input").show(); edward
                }
            })
            .fail(function (err) {
                //$(".company-input").show(); edward
            });
        };

        function getStores(id){
            var url = 'business-group/' + id;
            $.ajax({
                url: url,
                dataType: 'json'
            })
                .done(function (data) {
                    if(data.length != 0){
                        console.log(data);
                        $(".store-select select").html('<option value="">(Select one)</option>');
                        for(var i = 0 ; i < data.length; i++){
                            $(".store-select select").append(
                                '<option value="' + data[i].ID + '">' + data[i].BusinessName + '</option>'
                            );
                        }
                        $(".store-select select").append(
                            '<option value="0">Other</option>'
                        );
                        $(".store-select").show();
                    }else{
                        //$(".company-input").show(); edward
                    }
                })
                .fail(function (err) {
                    //$(".company-input").show(); edward
                });
        };

        $(".business-type-select input[type='radio']").change(function () {
            var id = $(".business-type-select input[type='radio']:checked").attr('value');
            $(".business-group-select").hide();
            $(".company-input").hide();
            $(".store-select").hide();
            if(id === '0'){
                //$(".company-input").show(); edward
            }else{
                getBusinessGroups(id);
            }
        });


        $(".business-group-select select").change(function () {
            var id = $(this).val();
            $(".store-select").hide();
            $(".company-input").hide();
            if(id === '0'){
                //$(".company-input").show(); edward
            }else{
                getStores(id);
            }
        });

        $(".store-select select").change(function () {
            var id = $(this).val();
            if(id === '0'){
                //$(".company-input").show(); edward
            }else{
                $(".company-input").hide();
            }
        });


        $('#Form_formSubmit, #Form_legacyFormSubmit').submit(function (e) {
            e.preventDefault();
            let _form = this;
            let hasError = false;

            $(".error-message").remove();
            $(".error").removeClass('error');

            $("input.requiredInput, select.requiredInput, textarea.requiredInput").each(function(){
                if(!$(this).val()){
                    hasError = true;
                    $(this).addClass('error');
                    let name = $(this).closest('div.requiredInput').find('label').eq(0).html();
                    $(this).after('<div class="error error-message body-copy small">' + name + ' is required</div>');
                }
            });

            if(!$('.agreement-checkbox').is(':checked')){
                $('.agreement-checkbox-container').append('<div class="error error-message body-copy small">Please accept the privacy policy</div>');
            }

            if($("#Form_formSubmit_Password").length != 0){
                if( $("#Form_legacyFormSubmit_Password").val() != ""){
                    if( $("#Form_formSubmit_Password").val().length < 6){
                        $("#Form_formSubmit_Password").after('<div class="error error-message body-copy small">Password must have at least 6 characters</div>');
                    }else if($("#Form_formSubmit_ConfirmPassword").val() != $("#Form_formSubmit_Password").val()) {
                        $("#Form_formSubmit_ConfirmPassword").after('<div class="error error-message body-copy small">Confirm password does not match</div>');
                    }
                }

            }

            if($("#Form_legacyFormSubmit_Password").length != 0){
                if( $("#Form_legacyFormSubmit_Password").val() != ""){
                    if( $("#Form_legacyFormSubmit_Password").val().length < 6){
                        $("#Form_legacyFormSubmit_Password").after('<div class="error error-message body-copy small">Password must have at least 6 characters</div>');
                    }else if($("#Form_formSubmit_ConfirmPassword").val() != $("#Form_legacyFormSubmit_ConfirmPassword").val()) {
                        $("#Form_formSubmit_ConfirmPassword").after('<div class="error error-message body-copy small">Confirm password does not match</div>');
                    }
                }
            }


            if($('.error:visible').length == 0){
                $(_form).unbind('submit');
                $(_form).find('input[type="submit"]').attr('disabled', 'disabled');
                $(_form).submit();
            }
        });

        $(".business-type-select input[type='radio']").change();


        var input = document.getElementById('Form_formSubmit_Address');
        var input2 = document.getElementById('Form_formSubmit_Address2');
        var options = {
            componentRestrictions: {
                country: "nz"
            }
        };
        if(input){
            new google.maps.places.Autocomplete(input2, options);
            var autocomplete = new google.maps.places.Autocomplete(input, options);

            autocomplete.addListener('place_changed', function () {
                var place = autocomplete.getPlace();

                for(var i = 0; i < place.address_components.length; i++){
                    var obj = place.address_components[i];
                    if(obj.types.includes("sublocality_level_1")){
                        $("#Form_formSubmit_Suburb").val(obj.long_name);
                    }
                    if(obj.types.includes("administrative_area_level_1")){
                        $("#Form_formSubmit_City").val(obj.long_name);
                    }
                    if(obj.types.includes("postal_code")){
                        $("#Form_formSubmit_Postcode").val(obj.long_name);
                    }
                }

            });
        }

        var profileInput = document.getElementById('Form_profileFormSubmit_Address');
        if(profileInput){
            var autocomplete = new google.maps.places.Autocomplete(profileInput, options);

            autocomplete.addListener('place_changed', function () {
                var place = autocomplete.getPlace();

                for(var i = 0; i < place.address_components.length; i++){
                    var obj = place.address_components[i];
                    if(obj.types.includes("sublocality_level_1")){
                        $("#Form_profileFormSubmit_Suburb").val(obj.long_name);
                    }
                    if(obj.types.includes("administrative_area_level_1")){
                        $("#Form_profileFormSubmit_City").val(obj.long_name);
                    }
                    if(obj.types.includes("postal_code")){
                        $("#Form_profileFormSubmit_Postcode").val(obj.long_name);
                    }
                }

            });
        }

    }
});


